import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FileSpreadsheet, Printer } from "lucide-react";
import { toast } from "sonner";
import { useQueryClient } from "@tanstack/react-query";
import { NeuButton } from "../../components/neu/Neu";
import { NEU_3D as BTN_3D } from "../../components/neu/NeuPicker";
import { downloadReport } from "../../api/payroll";
import { pdfTicket } from "../../api/reportTicket";
import { listSalaryHolds } from "../../api/salaryHolds";
import { useReportBrand } from "../reports/useReportBrand";
import { closeWindow, preopenWindow } from "../../features/reports/openShared";
import { openHoldsReport } from "./openHoldsReport";

const WIDE = "min-w-[104px] px-8 py-3 font-black flex items-center justify-center gap-2 !text-white";

// PDF يفتح تقرير الرواتب الموقوفة للطباعة (وفيه أزرار تحميل/مشاركة PDF)، و Excel يُنزّل الجدول.
export const HoldsExportBar = () => {
  const { t, i18n } = useTranslation();
  const brand = useReportBrand();
  const qc = useQueryClient();
  const [busy, setBusy] = useState(false);

  const print = async () => {
    const win = preopenWindow();
    if (!win) return toast.error(t("salaryReport.popupBlocked"));
    setBusy(true);
    try {
      // تذكرة الـPDF في الخلفية؛ نعرض التقرير فور جلب بياناته (كما في تقارير الرواتب/الحضور).
      const ticketPromise = pdfTicket("holds", { lang: i18n.language }).catch(() => null);
      const data = await (qc.getQueryData(["salary-holds"])
        || qc.fetchQuery({ queryKey: ["salary-holds"], queryFn: listSalaryHolds }));
      openHoldsReport(data, i18n.language, brand, win, ticketPromise);
    } catch {
      closeWindow(win);
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  const excel = async () => {
    setBusy(true);
    try {
      await downloadReport("/payroll/holds/export", { kind: "xlsx", lang: i18n.language }, "salary-holds.xlsx");
    } catch {
      toast.error(t("errors.generic"));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex gap-2">
      <NeuButton className={`${WIDE} bg-red-600 hover:bg-red-700`} style={BTN_3D}
                 data-testid="holds-print-report" disabled={busy} onClick={print}>
        <Printer className="h-5 w-5" /> <span className="text-base">PDF</span>
      </NeuButton>
      <NeuButton className={`${WIDE} bg-[#217346] hover:bg-[#1a5c38]`} style={BTN_3D}
                 data-testid="export-holds-xlsx" disabled={busy} onClick={excel}>
        <FileSpreadsheet className="h-5 w-5" /> <span className="text-base">Excel</span>
      </NeuButton>
    </div>
  );
};
